import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const title = theme => css`
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.medium};
`

const tagsList = css`
  gap: ${rem(4)};
  flex-wrap: wrap;
`

const emptyText = theme => css`
  font-size: ${theme.fontSize.small};
  font-style: italic;
`

export const styles = {
  title,
  tagsList,
  emptyText,
}
